import * as thesisMarksheetUrl from 'src/helpers/url_helper';
import { apiSlice } from 'src/rtk/api/apiSlice';

export const thesisMarksheetApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ['thesisDissertationList', 'ThesisMarking', 'ExaminerCreate'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getThesisDissertationFileListForAdminByPaginate: builder.query<
        any,
        PaginateForLogbookEntries
      >({
        query: (paginate) => {
          let url = `${thesisMarksheetUrl.GET_THESIS_DISSERTATION_FILE_LIST_FOR_ADMIN_BY_PAGINATE}?category=${'Thesis'}&`;

          if (paginate.page) {
            url += `page=${paginate.page}&`;
          }
          if (paginate.paginate_per_page) {
            url += `paginate_per_page=${paginate.paginate_per_page}`;
          }
          if (paginate.search) {
            url += `${paginate.search}`;
          }

          return {
            method: 'GET',
            url: url,
          };
        },

        providesTags: ['thesisDissertationList'],
      }),

      getNotifyTrainee: builder.query<APIResponse<any>, string>({
        query: (id: any) => ({
          method: 'GET',
          url: `${thesisMarksheetUrl.GET_NOTIFY_TRAINEE}/${id}`,
        }),

        providesTags: ['thesisDissertationList'],
      }),

      createThesisMarking: builder.mutation<APIResponse<any>, any>({
        query: (data) => ({
          method: 'POST',
          url: `${thesisMarksheetUrl.THESIS_MARKING_BY_EXAMINER}`,
          body: data,
        }),
        invalidatesTags: ['ThesisMarking'],
      }),

      createThesisExaminer: builder.mutation<APIResponse<any>, any>({
        query: (data) => ({
          method: 'POST',
          url: `${thesisMarksheetUrl.THESIS_DISSERTATION_THESIS_EXAMINER_CREATE}`,
          body: data,
        }),
        invalidatesTags: ['ExaminerCreate'],
      }),

      createApprovalByExaminer: builder.mutation<APIResponse<any>, string>({
        query: (data: any) => ({
          method: 'POST',
          url: `${thesisMarksheetUrl.GET_APPROVAL_BY_EXAMINER}`,
          body: data
        }),
        invalidatesTags: ['thesisDissertationList'],
      }),
    }),
  });

export const {
  useGetThesisDissertationFileListForAdminByPaginateQuery,
  useLazyGetNotifyTraineeQuery,
  useCreateThesisMarkingMutation,
  useCreateApprovalByExaminerMutation,
  useCreateThesisExaminerMutation,
} = thesisMarksheetApi;
